<template>
  <transition name="fade">
    <div
      v-show="list[id]"
      :id="'infotip-' + id"
      :key="id"
      class="infotip"
      :class="'infotip--' + direction"
    >
      <div class="infotip__content">
        <div
          v-if="icon"
          class="infotip__content__icon"
        >
          <svg-loader :src="icon" />
        </div>
        <div class="infotip__content__text">
          {{ text }}
        </div>
      </div>
      <div
        class="infotip__button"
        @click="close"
      >
        {{ dismissText }}
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Infotip',
  props: {
    id: String,
    text: String,
    icon: String,
    dismissText: {
      type: String,
      default: 'ENTENDI'
    },
    direction: {
      type: String,
      default: 'bottom'
    },
    autoOpenOnFirstDays: {
      type: Boolean,
      default: false
    },
    numberOfDaysToAutoOpen: {
      type: Number,
      default: 4
    },
    highlightTargetElement: {
      type: Boolean,
      default: false
    },
    neverOpenAgainAfterDismissed: {
      type: Boolean,
      default: true
    },
    closeOnMouseLeave: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPopup: false
    }
  },
  computed: {
    ...mapGetters({ list: 'tutorialsList' })
  },
  methods: {
    ...mapActions(['updateTutorialsList']),
    close() {
      this.updateTutorialsList({ tutorial: this.id, action: false })
      if (this.highlightTargetElement) {
        this.removeHighlightFromTargetElement()
      }
    },
    open() {
      if (this.highlightTargetElement) {
        this.setHighlightOnTargetElement()
      }
    },
    setHighlightOnTargetElement() {
      this.$nextTick(function () {
        let id = 'infotip-' + this.id
        let target = document.getElementById(id).nextElementSibling
        target.style['box-shadow'] = 'rgb(127, 26, 84) 0.6px -0.3px 0px 3px'
      })
    },
    removeHighlightFromTargetElement() {
      let id = 'infotip-' + this.id
      let target = document.getElementById(id).nextElementSibling
      target.style['box-shadow'] = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.infotip {
  position: fixed;
  z-index: 999;
  display: flex;
  flex-direction: column;
  border-radius: 11px;
  background-color: #7f1a54;
  color: white;
  padding: 15px 18px;
  cursor: default;
  width: 254px;

  &__content {
    width: 100%;
    display: flex;
    justify-items: center;
    flex-direction: row;
    border-bottom: 1px solid #580736;
    padding-bottom: 12px;
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      height: 75px;
    }

    &__icon {
      flex: 1;
      align-self: center;
      padding-right: 10px;
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        padding-bottom: 10px;
      }

      .md-icon {
        width: 90%;
        height: 90%;
        margin: 0;
      }
    }

    &__text {
      flex: 3;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 136.5%;
    }
  }
  &__button {
    cursor: pointer;
    align-self: flex-end;
    font-size: 12px;
    font-weight: bold;
    padding-top: 6px;
    margin-bottom: -4px;

    &:hover {
      color: #fcff8f;
    }
  }

  &--top,
  &--bottom,
  &--left,
  &--right {
    &:before {
      border: solid 15px transparent;
      content: '';
      position: absolute;
    }
  }

  &--top {
    transform: translate(-40%, -118%);
    margin-left: 100px;

    &:before {
      top: 95%;
      left: 7%;
      border: solid 15px transparent;
      border-top-color: #7f1a54;
    }
  }

  &--bottom {
    transform: translate(-45%, 1em);

    &:before {
      top: -23px;
      left: 50%;
      border-bottom-color: #7f1a54;
    }
  }

  &--right {
    transform: translate(25%, -60%);

    &:before {
      top: 33%;
      left: -25px;
      border: solid 15px transparent;
      border-right-color: #7f1a54;
    }
  }

  &--left {
    transform: translate(-100%, -50%);

    &:before {
      top: 20%;
      left: 98%;
      border: solid 15px transparent;
      border-left-color: #7f1a54;
    }
  }
}
</style>
